import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../../components/table';
import { getUsersInclusive } from '../../../reducers/users';
import { getFullName } from '../../../utilities/string';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { RoleDefinitions } from '../../../utilities/roles';
import { getProps } from '../../../utilities/common';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

class ClientUser extends React.Component {
    constructor(props) {
        super(props);
        this.getTableData = this.getTableData.bind(this);
    }

    getTableData() {
        const { user } = this.props;

        const roleLabel = role => {
            const definition = getProps(RoleDefinitions).find(r => r.type === role);
            return definition ? definition.label : role;
        };

        return {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                {
                    label: <FormattedMessage {...messages.role} />,
                    value: user.roles && user.roles[0] ? roleLabel(user.roles[0].role) : <FormattedMessage {...messages.notProvided} />
                },
                { label: <FormattedMessage {...messages.email} />, value: user.email },
                {
                    label: <FormattedMessage {...messages.phone} />,
                    value: user.phone ? formatPhoneNumberIntl(user.phone) : <FormattedMessage {...messages.notProvided} />
                }
            ]
        };
    }

    componentDidMount() {
        const { refId, refType, user, getUsersInclusive } = this.props;
        if (!user) {
            getUsersInclusive({ id: refId, type: refType }, undefined, []);
        }
    }

    render() {
        const { user } = this.props;
        if (!user) return null;

        return (
            <React.Fragment>
                <div className="row section">
                    <div className="col-xs-12">
                        <h4>{getFullName(user)}</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Table {...this.getTableData()} rowStyle={'onboarding-table-row'} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

ClientUser.defaultProps = {
    refId: undefined,
    refType: undefined,
    userId: undefined
};
ClientUser.propsTypes = {
    reftId: PropTypes.string.isRequired,
    refType: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => {
    const { userId } = props;
    return {
        user: state.users.list ? state.users.list.find(u => u.id === userId) : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUsersInclusive
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientUser);



// WEBPACK FOOTER //
// ./src/pages/user/tenants/client.jsx